import React from 'react';
import { Dumbbell, Activity, Heart, Users, Trophy, Apple } from 'lucide-react';

const ServicesSection = () => {
  const services = [
    {
      icon: <Dumbbell size={32} />,
      title: "Personal Training",
      description: "One-on-one customized training sessions tailored to your specific goals, fitness level, and timeline. Get undivided attention and expert guidance every step of the way."
    },
    {
      icon: <Trophy size={32} />,
      title: "Strength & Conditioning",
      description: "Build real, functional strength that translates to everyday life and athletic performance. Science-backed programming for maximum results and injury prevention."
    },
    {
      icon: <Activity size={32} />,
      title: "Corrective Exercise",
      description: "Address movement dysfunctions, muscle imbalances, and postural issues. Specialized programming to improve mobility, reduce pain, and optimize performance."
    },
    {
      icon: <Heart size={32} />,
      title: "Post-Rehabilitation Training",
      description: "Safely transition from physical therapy to full function. Expert guidance for post-surgical recovery and chronic condition management with evidence-based protocols."
    },
    {
      icon: <Users size={32} />,
      title: "Youth Athletic Development",
      description: "Age-appropriate training for young athletes. Focus on proper movement patterns, injury prevention, and building a foundation for long-term athletic success."
    },
    {
      icon: <Apple size={32} />,
      title: "Custom Nutrition Programming",
      description: "Personalized nutrition plans aligned with your training and goals. Sustainable strategies for fat loss, muscle gain, or performance optimization."
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Services</span>
          <h2 className="section-title">Comprehensive Training Solutions</h2>
          <p className="section-description">
            Whether you're just starting out or training at an elite level, 
            I offer specialized programs designed to help you reach your goals safely and effectively.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
